import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './lang'
import axios from 'axios'
import { store } from '@/api/store'

Vue.use(VueI18n)

const SUPPORTED_LANGS = ['ko', 'en', 'jp']

// URL에서 lang 파싱 (리로드 시 store 초기화 전에도 정확한 값 획득)
function getLangFromURL() {
  const lang = window.location.hash.split('/')[1]
  return SUPPORTED_LANGS.includes(lang) ? lang : null
}

const storedLang = getLangFromURL() || store.get('lang') || 'ko'

export const i18n = new VueI18n({
  locale: storedLang,
  fallbackLocale: 'ko',
  messages
})

// store 초기화 완료 후 호출 (store에 값이 있을 때만 적용)
export function initializeLocale(store) {
  const lang = store.get('lang')
  if (lang) {
    setI18nLanguage(lang)
    return lang
  }
  // store에 없으면 현재 값(URL 파싱 결과) 유지
  return i18n.locale
}

const loadedLanguages = ['ko'] // our default language that is prelaoded

export function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export function getCurrentLanguage () {
  return i18n.locale
}
